import { Component, Inject, LOCALE_ID, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { Company } from 'src/app/core/models/company';
import { Link } from 'src/app/core/models/link';
import { Page } from 'src/app/core/models/page';
import { SortData } from 'src/app/core/models/sort-data';
import { StockRecommendation } from 'src/app/core/models/stock-recommendation';
import { CompanyService } from 'src/app/core/services/company.service';
import { StockRecommendationService } from 'src/app/core/services/stock-recommendation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {
  domainURL=environment.domain+"/"+(this.localId+"").substring(0,2)+"/";
  stockRecommendation:StockRecommendation;
  stockRecommendationList:StockRecommendation[]= [];
  srList:StockRecommendation[]= [];
  companyInfo:Company;
  linkList: Link[];
  maxValue:StockRecommendation;
  minValue:StockRecommendation;
  page = new Page();
  pageInfo = new Page();
  sorts=new Array();
  isBrowser:any;
  commentCount: any;
  title: string;
  rootId: string;
  recommendationPage = new Page();
  toYear=(new Date()).getFullYear();
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    @Inject(LOCALE_ID) private localId: Object,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private companyService: CompanyService,
    private stockRecommendationService: StockRecommendationService) { }

  
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.stockRecommendationList=data.stockRecommendationDetailResolver?.data;
    })
    this.companyService.getByCode(this.stockRecommendationList[0]?.code).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.companyInfo = data;
    },
    error => {
      console.log("error: ",error);
    });
    this.pageInfo = new Page();
    this.pageInfo.pageNumber = 1;
    this.pageInfo.size = 5;  
    this.sorts=[{"dir": "desc", "prop": "targetPrice"}]
    this.setPage(this.pageInfo) ;
  }
  
	public beforeChange($event: NgbPanelChangeEvent) {
    this.route.data.subscribe(data => {
      this.stockRecommendationList=data.stockRecommendationDetailResolver;
    })
	}

  setPage(pageInfo) {
    this.pageInfo = pageInfo;
    let sortData=new SortData<StockRecommendation>();
    let sr = new StockRecommendation();
    sr.lang="tr";
    sr.country="tr";
    sr.status=true;
    sr.type="TARGET";
    sr.code=this.stockRecommendationList[0]?.code;
    sortData.filter=sr;
    sortData.sorts=this.sorts;
    this.pageInfo.pageNumber = this.pageInfo.pageNumber - 1;
    this.stockRecommendationService.getPageAbleList(this.pageInfo,sortData).pipe(takeUntil(this.destroy$)).subscribe(pagedData => {
      this.pageInfo = pagedData.page;
      this.page.pageNumber = this.page.pageNumber-1;
      this.srList = pagedData.data; 
      this.maxValue = this.srList.reduce((prev, current) => (prev.targetPrice > current.targetPrice) ? prev : current)
      this.minValue = this.srList.reduce((prev, current) => (prev.targetPrice < current.targetPrice) ? prev : current)
    },
    error => {
      console.error("error: ",error);
    });
  }
  
  public trackByBrokerageFirm(index, item) {
    if (!item) return null;
    return item.id;
  }
}
